import { render, staticRenderFns } from "./HomeVoiceService.vue?vue&type=template&id=6c6dc2ee&"
import script from "./HomeVoiceService.vue?vue&type=script&lang=js&"
export * from "./HomeVoiceService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports